'use strict';

import 'angular';

import addressFilter from './address';
import teamListFilter from './team-list';
import chooseTeamListFilter from './choose-team-list';
import logPathFilter from './log-path';
import hasLabelFilter from './has-label';
import versionDisplayNameFilter from './version-display-name';

const MODULE_NAME = 'daupler.incidents.filters';

var app = angular.module(MODULE_NAME, [
]);
app.filter('address', addressFilter);
app.filter('teamList', teamListFilter);
app.filter('chooseTeamList', chooseTeamListFilter);
app.filter('hasLabel', hasLabelFilter);
app.filter('versionDisplayName', versionDisplayNameFilter);

export default MODULE_NAME;
